import { useContext } from 'react';

import Card3D from '@/components/game/3d/object/card/Card3D';
import { stepStackedCardY } from '@/const/magicNumber';
import { ViewContext } from '@/state/contexts';
import { getCardTexturePath } from '@/util/card';

const ActiveContractsAndAwardsBuilder = ({
	playerId,
	activeContractsAndAwards,
}) => {
	const {
		// showCardTableModal,
		setShowCardTableModal,
		// cardsOnTablePlayerId,
		setCardsOnTablePlayerId,
	}: any = useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	function displayCardsOnTableForPlayerId() {
		setCardsOnTablePlayerId(playerId);
		setShowCardTableModal(true);
	}

	if (
		activeContractsAndAwards == null ||
		activeContractsAndAwards.length === 0
	) {
		return;
	}

	const acaArray: any = [];

	for (let z = activeContractsAndAwards.length - 1; z >= 0; z--) {
		const texturePath = getCardTexturePath(activeContractsAndAwards[z]);

		acaArray.push(
			<group
				key={`aca_group__${z}`}
				position={[-8.5, stepStackedCardY * (z / 2), -1.5 + 1.5 * z]}
			>
				<Card3D
					key={`aca__${z}`}
					texturePath={texturePath}
					cardArr={activeContractsAndAwards}
					viewCardModal={displayCardsOnTableForPlayerId}
				/>
			</group>
		);
	}

	return <>{acaArray}</>;
};

export default ActiveContractsAndAwardsBuilder;
